import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@common-web/components/ui/dialog';
import {POSTHOG_UNMASK_CLASS} from '@common-web/lib/analytics';
import {useEnrollSteps} from '@client/pages/public/enroll/enrollStepsContext';
import {enrollBrandVars} from '@client/pages/public/enroll/brand';

interface SkipProductDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  /** "Dental" or "Vision". */
  productLabel: string;
}

/**
 * Lightweight confirm for skipping an ancillary product (dental/vision)
 */
export function SkipProductDialog({open, onOpenChange, onConfirm, productLabel}: SkipProductDialogProps) {
  const {group} = useEnrollSteps();
  const label = productLabel.toLowerCase();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        style={enrollBrandVars(group.primaryColor)}
        className={`max-w-md ${POSTHOG_UNMASK_CLASS}`}
      >
        <DialogHeader>
          <DialogTitle className='text-[var(--enroll-ink)]'>Skip {productLabel}?</DialogTitle>
        </DialogHeader>

        <DialogDescription className='text-sm leading-relaxed text-neutral-600'>
          Skipping {label} means you won't be enrolled in this benefit for the upcoming year. You can
          add it again at the next open enrollment, without any extra paperwork.
        </DialogDescription>

        <div className='flex flex-col-reverse gap-2 sm:flex-row sm:justify-end'>
          <button
            type='button'
            onClick={() => onOpenChange(false)}
            className='inline-flex h-11 items-center justify-center rounded-lg border border-neutral-300 px-5 text-sm font-semibold text-neutral-700 transition-colors hover:bg-neutral-100'
          >
            Keep looking
          </button>
          <button
            type='button'
            onClick={onConfirm}
            className='inline-flex h-11 items-center justify-center rounded-lg bg-[var(--enroll-accent)] px-5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-[var(--enroll-accent-hover)]'
          >
            Yes, skip {label}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
